"use strict";
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "managedcareplansection",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	reset: reset,
	refresh: refresh,
	track: track,
	start_save: start_save,
	sayViewing: sayViewing,

	_who: null,
	_group: null,
	_who_tracker: null,
	_schema: null,
});

function init() {
	this._who_tracker = this.dispatcher.createTracker();

	this.reset();
}

function uninit() {
	this._schema = null;
	this.reset();
	this._who_tracker = null;
}

function triggers() {
	return {
		view: viewSection,
		edit: edit,
		reset: reset
	};
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"careplanschema:updated": handle_careplan_schema_updated,
	};
}

function viewSection(data) {
	var section = data.section;
	var who = data.who;
	var group = data.group;


	if ((section === this._section) && (who === this._who))
		return this.sayViewing();

	this.emit("careplanschema:trigger:load");

	this._who = who;
	this._group = group;
	this._section = section;
	this.track();
	this.refresh().then(sayViewing.bind(this));
	this.emit("managedcareplanproposedchanges:trigger:view", data);
}

function reset() {
	this._who = null;
	this._group = null;
	this._section = null;
	this._who_tracker.off();
	this.extend({});
	this.emit("managedcareplanproposedchanges:trigger:reset");
}

function edit() {
	var section = this._section;
	var who = this._who;
	var group = this._group

	this.emit("managedcareplansectioneditor:trigger:start", {
		who: who,
		section: section,
		group: group
	});
}

function track() {
	var who = this._who;
	var section = this.data.section;
	this._who_tracker.on("u/" + who + "/careplan/" + section + "/updated", this.extend.bind(this));
}

function refresh() {
	var section = this._section;
	var who = this._who;
	var group = this._group;
	if (!section) return;
	if (!who) return;
	var apiCall = this.api.manage.careplan[section.toLowerCase()].data;
	if(!apiCall) return;
	this.start_save();
	return apiCall(who, group)
		.then(setData.bind(this, section))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this));
}

function setData(section, data) {
	var newData = {};
	if(section)
		newData.section = section;
	if(this._schema)
		newData.schema = this._schema.data.properties[this._section];
	this.push(xtend(data || {}, newData));
}

function start_save() {
	this.emit("save:trigger:start");
}

function finish_save() {
	this.emit("save:trigger:finish");
}

function sayViewing() {
	this.dispatch("viewing", {
		section: this._section
	});
}

function handle_careplan_schema_updated(schema) {
	if(!this._section) return;

	this._schema = schema;
	this.extend({
		schema: this._schema.data.properties[this._section],
		section: this._section
	});
}
